var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoKompressor48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.7,12.5c-6.2,0-11.2,5.2-11.2,11.5c0,6.3,5,11.5,11.2,11.5c6.2,0,11.2-5.2,11.2-11.5C33.9,17.7,28.9,12.5,22.7,12.5z  M13.4,24c0-2.9,1.2-5.4,3.2-7.2l14.6,3.4c0.5,1.2,0.8,2.4,0.8,3.8c0,1.5-0.3,2.9-0.9,4.1l-14.2,3.3C14.8,29.7,13.4,27,13.4,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,29.2L35,29.2c0,0-1.5,3.4-1.5,4.3c0,0.9,1,1.4,1.4,1.4h0.1c0.5,0,1.4-0.5,1.4-1.4C36.5,32.6,35,29.2,35,29.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.3,
    y: 23.3,
    width: 6.2,
    height: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoKompressor48);
export default __webpack_public_path__ + "static/media/ic_bevo_kompressor_48.5854e229c351a5cc02e6d7ea3443343e.svg";
export { ForwardRef as ReactComponent };